import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
  DataTypeProvider,
  SortingState,
  IntegratedSorting,
  FilteringState,
  IntegratedFiltering,
  SelectionState,
  IntegratedSelection,
} from '@devexpress/dx-react-grid'
import {
  Grid,
  Table,
  TableHeaderRow,
  TableFilterRow,
  TableSelection,
} from '@devexpress/dx-react-grid-material-ui';

import FileUploadIcon from '@material-ui/icons/CloudUpload';

import ReactFileReader from 'react-file-reader';
import * as Papa from 'papaparse';

import PhoneFormat from './format/PhoneFormat.js';

import moment from 'moment';

// import firebase from 'firebase/app';
// require("firebase/firestore");

const getRowId = row => row.id;

const columns = [
  { name: 'name', title: 'Name' },
  { name: 'email', title: 'Email' },
  { name: 'phone', title: 'Phone' },
  { name: 'gender', title: 'Gender' },
  { name: 'occupation', title: 'Occupation' },
  { name: 'dob', title: 'DOB' },
];
const columnExtensions = [
  { columnName: 'phone', width: 100 },
  { columnName: 'gender', width: 100 },
  { columnName: 'dob', width: 120 },
];

const headerMap = [
  { headerName: "Name", tableName: "name" },
  { headerName: "Birthday", tableName: "dob" },
  { headerName: "Gender", tableName: "gender" },
  { headerName: "Occupation", tableName: "occupation" },
  { headerName: "E-mail 1 - Value", tableName: "email" },
  { headerName: "Phone 1 -Value", tableName: "phone" },
];

const PhoneTypeProvider = () => (
  <DataTypeProvider
    for={['phone']}
    formatterComponent={({ value }) => <PhoneFormat displayType='text' value={value} /> }
  />
);

const DobTypeProvider = () => (
  <DataTypeProvider
    for={['dob']}
    formatterComponent={({ value }) => value ? moment(value).format('ll') + " (" + moment().diff(moment(value), 'years') + ")" : ''}
  />
);

const GenderTypeProvider = () => (
  <DataTypeProvider
    for={['gender']}
    formatterComponent={({ value }) => value === 'F' ? 'Female' : value === 'M' ? 'Male' : '' }
  />
);

class ImportCustomerDialog extends Component {
  state = {
    open: this.props.open,
    rows: [],
    selection: [],
  }

  handleCsvFile = file => {
    Papa.parse(file[0], {
      header: true,
    	complete: results => {
    		// console.log(results);
        var rows = [];
        results.data.forEach((dataRow, index) => {
          var newRow = { id: index };
          headerMap.forEach(map => {
            newRow[map.tableName] = dataRow[map.headerName];
          });
          rows.push(newRow);
        });

        this.setState({
          rows: rows,
        });
    	},
      error: () => {
        this.setState({
          rows: [],
        });
      }
    });
  }

  changeSelection = selection => {
    this.setState({ selection });
  }

  handleImportClick = () => {

  }

  handleRequestClose = () => {
    this.setState({ open: false });
    this.props.onRequestClose();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.state.open) {
      this.setState({
        open: nextProps.open,
        rows: []
     });
    }
  }

  render() {
    return (
      <Dialog
        maxWidth="md"
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        onClose={this.handleRequestClose}
        open={this.state.open}>
        <DialogTitle>Import Customers</DialogTitle>

        <DialogContent style={{ paddingTop: 3 }}>

          <ReactFileReader handleFiles={this.handleCsvFile} fileTypes={'.csv'}>
            <Button style={{ marginBottom: 16 }}><FileUploadIcon />Upload</Button>
          </ReactFileReader>

          <Paper>
            <Grid
              rows={this.state.rows}
              getRowId={getRowId}
              columns={columns}>

              <PhoneTypeProvider />
              <DobTypeProvider />
              <GenderTypeProvider />

              {/* Sorting */}
              <SortingState
                defaultSorting={[ {columnName: 'transactionDate', direction: 'desc'}, ]} />
              <IntegratedSorting />

              {/* Filter */}
              <FilteringState />
              <IntegratedFiltering />

              {/* Selection */}
              <SelectionState
                selection={this.state.selection}
                onSelectionChange={this.changeSelection}
              />
              <IntegratedSelection />

              <Table columnExtensions={columnExtensions} />
              <TableHeaderRow showSortingControls />
              <TableFilterRow />
              <TableSelection showSelectAll />

            </Grid>
          </Paper>

        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleRequestClose} >Close</Button>
          <Button
            color="primary"
            disabled={this.state.rows.length === 0}
            onClick={this.handleImportClick}
          >
            Import
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

ImportCustomerDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

export default ImportCustomerDialog;
